import { CompanyAccountModelDto } from '@treasury/api/channel';
import { emptyCompanyAccount } from '../company/company-account.entity';

export const nullWireAccount: CompanyAccountModelDto = {
    ...emptyCompanyAccount,
    account: {
        ...(emptyCompanyAccount.account as NonNullable<CompanyAccountModelDto['account']>),
        type: 'Checking',
    },
    type: 'Checking',
};
